var render, staticRenderFns
import script from "./more-data.vue?vue&type=script&lang=js&"
export * from "./more-data.vue?vue&type=script&lang=js&"
import style0 from "./more-data.vue?vue&type=style&index=0&id=2aed10c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aed10c2",
  null
  
)

export default component.exports